// extracted by mini-css-extract-plugin
export default {"scope":"pqsRS","scope--is-visible":"qabmR","upload-icon":"Ha+0s","bounce":"UyPGH","message":"yfQp6","folder":"RObiV","folder-icon":"wRg5E"};